import { trpc } from "../../../lib/api/trpc";

export type DocumentRetrievalStats = {
  totalCitations: number;
  totalRetrievals: number;
  uniqueConversations: number;
  mostCitedChunks: Array<{
    chunkIndex: number;
    citationCount: number;
  }>;
};

export const useDocumentRetrievalStats = (documentId: string) => {
  // @ts-ignore - tRPC type inference through `as any` router cast
  const { data, isLoading, isError, error, refetch } =
    trpc.documents.getRetrievalStats.useQuery(
      { documentId },
      { enabled: !!documentId },
    );

  return {
    stats: data as DocumentRetrievalStats | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
